export default __webpack_public_path__ + "static/media/approveIconFlat.4176140d.svg";